import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { QueryParam } from '../query-param';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-comviva-dialog',
  templateUrl: './comviva-dialog.component.html',
  styleUrls: ['./comviva-dialog.component.css']
})
export class ComvivaDialogComponent implements OnInit {

  constructor(private apiService: ApiService,private  activeModal: NgbActiveModal,
    private activatedRoute: ActivatedRoute, private router:Router) { }

    mobileNumber!: number;

    addbalance = '';
    queryParam!: QueryParam;
    enter = '';

    
  
    ngOnInit(): void {
      let storageName = this.apiService.getItem();
      this.queryParam = JSON.parse(
        localStorage.getItem(storageName) || 'undefined'
        );
        console.log('this.queryParam :', this.queryParam);

        if(this.queryParam.id === '519' || '530' && this.queryParam.biller === 'COMVIVA'){
          this.enter = "Enter Mobile Number With Country Code :"
        }else{
          this.enter = "Enter Mobile Number :"
        }

    }
  
    submit(){
      if(this.queryParam.biller != 'COMVIVA' && this.queryParam.id != '530' && '519' && '447'){
      console.log(this.mobileNumber);
        this.apiService.getMobileResponseFORCOMVIVA447(this.getConditionalDialogBox(this.mobileNumber)).subscribe(
          (response: any) => {
  
            let data = JSON.parse(response);
            console.log('JSON.parse(response)',JSON.parse(response));
            
            if(this.queryParam.id == '447' || this.queryParam.id == '532'){
              if(data.currentStstus == "ACTIVE"){
                response = "true";
              }else{
                response = "false";
              }
            }
            console.log('Mobile Reponse ===============', response);
            console.log("STATUS",response)
            if(response == "true"){
              this.queryParam.mobileNumber = this.mobileNumber;
              this.queryParam.msisdn = this.mobileNumber.toString();
  
              this.queryParam.sub = true;
              this.queryParam.popup = false;
            //  let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
              localStorage.setItem(this.apiService.getItem(), JSON.stringify(this.queryParam));
             console.log('Response :', this.queryParam);
              this.activeModal.close();
  
              const url = this.router.createUrlTree([], {relativeTo: this.activatedRoute, 
                queryParams: {msisdn: this.mobileNumber},
                queryParamsHandling: "merge", 
                preserveFragment: true}).toString()
  
              this.router.navigateByUrl(url);
  
            }else{
              if(this.queryParam.lang == 'SW'){
                this.addbalance = "Du är inte prenumererad";
              }else{
                this.addbalance = "You are not subscribed"; 
              }
            }
          },
          (err: HttpErrorResponse) => {
            console.log(err);
          }
        );
    }else if(this.queryParam.id === '519' || '447' || '530' && this.queryParam.biller === 'COMVIVA'){
          let url = 'http://wap.matrixads.in/mglobopay/getSubDataById?msisdn='+this.queryParam.msisdn+'&serviceid='+this.queryParam.serviceId
          this.apiService.getSubDataByID(this.mobileNumber, this.queryParam.serviceId).subscribe(
            (res: any) => {
              console.log("HIIIIIIIIIIIIIIIIIIIII",res);
    
              // let data = JSON.parse(response);
              // console.log('JSON.parse(response)',JSON.parse(response));
              let data = res;
              
              // if(this.queryParam.id == '447' || this.queryParam.id == '532'){
              //   if(data.currentStstus == "ACTIVE"){
              //     response = "true";
              //   }else{
              //     response = "false";
              //   }
              // }
              console.log('Mobile Reponse ===============', res);
              console.log("STATUS",res)
              if(data.currentStstus === 'ACTIVE'){
                this.queryParam.mobileNumber = this.mobileNumber;
                this.queryParam.msisdn = this.mobileNumber.toString();
    
                this.queryParam.sub = true;
                this.queryParam.popup = false;
              //  let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
                localStorage.setItem(this.apiService.getItem(), JSON.stringify(this.queryParam));
               console.log('Response :', this.queryParam);
                this.activeModal.close();
    
                const url = this.router.createUrlTree([], {relativeTo: this.activatedRoute, 
                  queryParams: {msisdn: this.mobileNumber},
                  queryParamsHandling: "merge", 
                  preserveFragment: true}).toString()
    
                this.router.navigateByUrl(url);
    
              }else{               
                 this.addbalance = "You are not subscribed";                        
              }
            },
            (err: HttpErrorResponse) => {
              console.log(err);
            }
          );
        };
  
      //}
    }

    submitActel(){
      let url = 'http://wap.matrixads.in/mglobopay/getSubDataById?msisdn='+this.queryParam.msisdn+'&serviceid='+this.queryParam.serviceId
      this.apiService.getSubDataByID(this.mobileNumber, this.queryParam.serviceId).subscribe(
        (res: any) => {
          console.log("HIIIIIIIIIIIIIIIIIIIII",res);
          let data = res;
          console.log('Mobile Reponse ===============', res);
          console.log("STATUS",res)
          if(data.currentStstus === 'ACTIVE'){
            this.queryParam.mobileNumber = this.mobileNumber;
            this.queryParam.msisdn = this.mobileNumber.toString();

            this.queryParam.sub = true;
            this.queryParam.popup = false;
          //  let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
            localStorage.setItem(this.apiService.getItem(), JSON.stringify(this.queryParam));
           console.log('Response :', this.queryParam);
            this.activeModal.close();

            const url = this.router.createUrlTree([], {relativeTo: this.activatedRoute, 
              queryParams: {msisdn: this.mobileNumber},
              queryParamsHandling: "merge", 
              preserveFragment: true}).toString()

            this.router.navigateByUrl(url);

          }else{
            if(this.queryParam.lang == 'SW'){
              this.addbalance = "Du är inte prenumererad";
            }else{
              this.addbalance = "You are not subscribed"; 
            }
          }
        },
        (err: HttpErrorResponse) => {
          console.log(err);
        }
      );
    }
  
    getConditionalDialogBox(mobileNumber:any){
      if((this.queryParam.id == '375') && this.queryParam.biller.toLowerCase() == "QANAWAT".toLowerCase()){
        return "http://wap.matrixads.in/mglobopay/qanawatKSAPortalValidation/"+mobileNumber;
       }else if((this.queryParam.id == '401') && this.queryParam.biller.toLowerCase() == "ALTRUS".toLowerCase()){
  
        return "http://wap.matrixads.in/mglobopay/altrusCheckSubscriptionStatus?msisdn="+mobileNumber;
  
       }else if((this.queryParam.id == '453' || this.queryParam.id == '454') && this.queryParam.biller.toLowerCase() == "MTNMONEY".toLowerCase()){
  
          return "https://wap.matrixads.in/mglobopay//fetchMTNBeninSubscriptionStatus/"+this.queryParam.serviceId+"/"+mobileNumber;
  
      }else if((this.queryParam.id == '481') && this.queryParam.biller.toLowerCase() == "ONE97".toLowerCase()){
  
        return "https://wap.matrixads.in/mglobopay/uaeONSSubscriptionStatus?msisdn="+mobileNumber;
  
    }
      else if((this.queryParam.id == '420' || this.queryParam.id == '421') && this.queryParam.biller.toLowerCase() == "AirtelMoney".toLowerCase()){
  
          return "https://wap.matrixads.in/mglobopay//fetchAirtelNigerSubscriptionStatus/"+this.queryParam.serviceId+"/"+mobileNumber;
  
      }else if(this.queryParam.id === '6' && this.queryParam.biller === 'TPAY' && (this.queryParam.operator === "9071" || this.queryParam.operator === "9073")){
        return "http://wap.matrixads.in/mglobopay/tpaygamesworldPortalValidation/"+mobileNumber;
      }else if(this.queryParam.id === '297' && this.queryParam.biller === 'MediaWorld' && this.queryParam.operator === "8938"){
        return "http://wap.matrixads.in/mglobopay/mediaWorldSubscriptionStatus/52/"+mobileNumber;
      }else if((this.queryParam.id == '416') && this.queryParam.biller.toLowerCase() == "MediaWorld".toLowerCase()){
  
        if(this.queryParam.serviceId == undefined || this.queryParam.serviceId == ''){
          this.queryParam.serviceId = "11166";
        }
       
         return "http://wap.matrixads.in/mglobopay/mediaWorldSubscriptionStatus/"+this.queryParam.serviceId+"/"+mobileNumber;
        
      }else if((this.queryParam.id == '490' || this.queryParam.id == '427') && this.queryParam.biller.toLowerCase() == "SLADigital".toLowerCase()){
  
        if((this.queryParam.serviceId == undefined || this.queryParam.serviceId == '') && this.queryParam.id == '490'){
          this.queryParam.serviceId = "1319";
        }else if((this.queryParam.serviceId == undefined || this.queryParam.serviceId == '') && this.queryParam.id == '427'){
          this.queryParam.serviceId = "1321";
        }
       
         return "http://wap.matrixads.in/mglobopay/SlaDigitalSubscriptionStatus?msisdn="+mobileNumber+"&serviceId="+this.queryParam.serviceId;
        
      }else if((this.queryParam.id == '447') && this.queryParam.biller.toLowerCase() == "SLADigital".toLowerCase()){
        
          // this.queryParam.serviceId = "1349";
        
         return "http://wap.matrixads.in/mglobopay/getSubDataById?serviceid="+this.queryParam.serviceId+"&msisdn="+mobileNumber;
      }
  
      else if((this.queryParam.id == '447') && this.queryParam.biller.toLowerCase() == "SLADigital".toLowerCase()){
        
        // this.queryParam.serviceId = "1349";
      
       return "http://wap.matrixads.in/mglobopay/getSubDataById?serviceid="+this.queryParam.serviceId+"&msisdn="+mobileNumber;
    }
  
    else if(this.queryParam.id == '532' && this.queryParam.biller.toLowerCase() == 'Sunych'.toLowerCase()){
        
        return "http://103.127.157.215:8080/mglobopay/getSubDataById?serviceid="+this.queryParam.serviceId+"&msisdn="+mobileNumber;
      
    }
  
    else if (this.queryParam.id == '519' && this.queryParam.biller.toLowerCase() == 'COMVIVA'.toLowerCase()){
      
    }
  
       return null;
    }
  }

